import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import {
  Feed,
  Header,
  Segment,
  Message,
  Icon,
  Button,
} from "semantic-ui-react";

import { DealerRepInfo } from "components/shared";

class Dashboard extends React.Component {
  state = {
    loading: false,
    salespeople: [],
    re_execute_contracts: [],
    approved_contracts: [],
  };

  componentDidMount = () => {
    axios.get("/dashboard/").then((res) => {
      const { salespeople, re_execute_contracts, approved_contracts } =
        res.data;

      this.setState({
        loading: false,
        salespeople,
        re_execute_contracts,
        approved_contracts,
      });
    });
  };

  render() {
    const { verified } = this.props;
    const { salespeople, approved_contracts, re_execute_contracts, loading } =
      this.state;

    if (!verified) {
      return (
        <React.Fragment>
          <DealerRepInfo fetchUrl={`/profile/`} />
          <Message
            as={Link}
            to={`/dealer/profile`}
            size="large"
            header="You're Unverified"
            error
            icon="exclamation circle"
            content="Click here to view and manage your documents"
          />
        </React.Fragment>
      );
    }

    return (
      <div>
        <DealerRepInfo fetchUrl={`/profile/`} />
        <Message icon size="large" positive>
          <Icon name="star" color="yellow" />
          <Message.Content>
            <Message.Header>New Site Features</Message.Header>
            Calculate rates for customers without starting a contract by
            clicking on the pink calculator on the bottom right of the page.
          </Message.Content>
        </Message>
        <Segment loading={loading} padded>
          <Feed size="large">
            <Header as="h3" dividing content="New Salespeople" />
            {salespeople.length > 0 ? (
              salespeople.map((person) => {
                return (
                  <Feed.Event key={person.id}>
                    <Feed.Label>
                      <Icon name="user" color="blue" />
                    </Feed.Label>
                    <Feed.Content>
                      <Feed.Summary>
                        {person.first_name} {person.last_name} is now a
                        salesperson
                      </Feed.Summary>
                      <Feed.Extra>{person.dealer.name}</Feed.Extra>
                      <Feed.Extra>
                        <Button
                          basic
                          size="mini"
                          as={Link}
                          content="View"
                          to={`/dealer/salespeople/${person.id}`}
                        />
                      </Feed.Extra>
                    </Feed.Content>
                  </Feed.Event>
                );
              })
            ) : (
              <p>Nothing new...</p>
            )}
            <Header as="h3" dividing content="New Approved Contracts" />
            {approved_contracts.length > 0 ? (
              approved_contracts.map((contract) => {
                return (
                  <Feed.Event key={contract.id}>
                    <Feed.Label>
                      <Icon name="check" color="green" />
                    </Feed.Label>
                    <Feed.Content>
                      <Feed.Summary>
                        Approved Contract
                        <Feed.Date content={contract.submitted_at_formatted} />
                      </Feed.Summary>
                      <Feed.Extra text>
                        Final Cost of Unit: ${contract.final_cost_of_unit}
                      </Feed.Extra>
                      <Feed.Extra>
                        <Button
                          basic
                          size="mini"
                          as={Link}
                          content="View"
                          to={`/dealer/contracts/${contract.id}`}
                        />
                      </Feed.Extra>
                    </Feed.Content>
                  </Feed.Event>
                );
              })
            ) : (
              <p>Nothing new...</p>
            )}
            <Header as="h3" dividing content="New Re-Executed Contracts" />
            {re_execute_contracts.length > 0 ? (
              re_execute_contracts.map((contract) => {
                return (
                  <Feed.Event key={contract.id}>
                    <Feed.Label>
                      <Icon name="exclamation" color="red" />
                    </Feed.Label>
                    <Feed.Content>
                      <Feed.Summary>
                        {contract.dealer.name} has a contract that needs to be
                        re-signed
                        <Feed.Date content={contract.submitted_at_formatted} />
                      </Feed.Summary>
                      <Feed.Extra text>
                        Final Cost of Unit: ${contract.final_cost_of_unit}
                      </Feed.Extra>
                      <Feed.Extra>
                        <Button
                          basic
                          size="mini"
                          as={Link}
                          content="View"
                          to={`/dealer/contracts/${contract.id}`}
                        />
                      </Feed.Extra>
                    </Feed.Content>
                  </Feed.Event>
                );
              })
            ) : (
              <p>Nothing new...</p>
            )}
          </Feed>
        </Segment>
      </div>
    );
  }
}

export default Dashboard;
